"use client";
import React, { useEffect, useState } from "react";
import PortfolioServicesCard from "../cards/PortfolioServicesCard";
import {
  PortfolioApiQuestion,
  PortfolioPlanCardProps,
} from "@/type/servicesPageTypes";

export default function HomePortfolioServicesSection({
  quesData,
  isAssessmentSubmitted,
  debt_inv_amount,
  hni_inv_amount,
  mf_suggestions,
  portfolio_review,
}: {
  quesData?: PortfolioApiQuestion[];
  isAssessmentSubmitted: boolean;
  debt_inv_amount: string;
  hni_inv_amount: string;
  mf_suggestions: string;
  portfolio_review: string;
}) {
  const [highlightedCard, setHighlightedCard] = useState<number | null>(null);

  useEffect(() => {
    const handleHighlight = (e: Event) => {
      const customEvent = e as CustomEvent;
      setHighlightedCard(customEvent.detail);
      setTimeout(() => setHighlightedCard(null), 3000);
    };

    window.addEventListener("highlightMfGuidanceCard", handleHighlight);
    return () =>
      window.removeEventListener("highlightMfGuidanceCard", handleHighlight);
  }, []);

  const plans: PortfolioPlanCardProps[] = [
    {
      title: "Build Your First Portfolio",
      subtitle: "First Time Investors",
      icon: "chart",
      priceNote: "Unlocked via Debt Fund investment",
      investment: debt_inv_amount,
      includes: [
        "Profiling & Goal Assessment",
        "SIP & fund selection",
        "Portfolio Tailored to Your Goals",
        "Complete Investment Support",
      ],
      footerNote: "Not suitable for portfolios above ₹10 Lakhs",
      buttonText: "Start Building My Portfolio",
      buttonUrl: "?plan=pf-personal",
    },
    {
      title: "Mutual Fund Suggestions",
      subtitle: "New Investors",
      icon: "diamondguidance",
      priceNote: "via Investment in Debt Fund",
      investment: mf_suggestions,
      includes: [
        "Category Wise Fund Shortlist",
        "Risk Match Analysis",
        "Why this Fund",
        "On boarding Assistance",
      ],
      footerNote: "Ideal if you want fund ideas without full portfolio ",
      buttonText: "Get My Fund Shortlist",
      buttonUrl: "?plan=mf-suggestions",
    },
    {
      title: "Portfolio Review",
      subtitle: "Existing Investors ",
      icon: "glass2",
      priceNote: "via Investment in Debt Fund",
      investment: portfolio_review,
      includes: [
        "CAS-based portfolio analysis",
        "Overlap & risk diagnostics",
        "Rebalancing & Switch Plan",
        "Review & Follow-Up",
      ],
      footerNote: "Not Suitable for First Time Investors",
      buttonText: "Review My Portfolio",
      buttonUrl: "?plan=pf-review",
    },
    {
      title: "HNI-Level MF Guidance",
      subtitle: "For ₹10L+ Investments",
      icon: "Page",
      priceNote: "via Investment in Debt Fund",
      investment: hni_inv_amount,
      includes: [
        "Private Investment Advisory",
        "Core–Satellite portfolio strategy",
        "Wealth Planning Support",
        "Priority & Execution Support",
      ],
      footerNote: "Limited HNI Clients Slots",
      buttonText: "Request a Private Strategy Session",
      buttonUrl: "?plan=mf-hni",
    },
  ];

  return (
    <div className="flex flex-col justify-center items-center xs:flex-row xs:flex-wrap xl:grid xl:grid-cols-2 xl:w-fit xl:mx-auto gap-5 md:gap-10 mb-8">
      {plans.map((plan, i) => (
        <PortfolioServicesCard
          key={i}
          {...plan}
          quesData={quesData ?? []}
          defaultOpen={i === 0}
          isHighlighted={highlightedCard === i}
          isAssessmentSubmitted={isAssessmentSubmitted}
        />
      ))}
    </div>
  );
}
